import Helpers from "../../helpers/helpers";
import { server } from "../globalSettings";


export const requestAuthOption = (method, data) => {
    let isRemember = localStorage.getItem("remember");
    let token = JSON.parse(localStorage.getItem("token"))

    if (data) {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, },
            body: JSON.stringify(data)
        };
        return requestOptions
    } else {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, },
        };
        return requestOptions
    }

}
// api
export const roleListingApi = async ({ length, page, sortOrder, sort, search }) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(`${server}role?sort_order=${sortOrder}&sort=${sort}&size=${length}&paginate=${page}&search=${search}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data.data);
                    } else {
                        reject(["Username and password are invalid. Please enter correct rolename and password"]);
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
        // if (response.ok) {
        //     const data = await response.json(); // Parse JSON data
        //     if (data.code === "success") {
        //         return data; // Return the data
        //     } else {
        //         apiError("Username and password are invalid. Please enter correct rolename and password");
        //         return false; // Custom error message
        //     }
        // } else {
        //     throw new Error('Network response was not ok');
        // }
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};

export const roleDetailsApi = async ({ id }) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(`${server}role/${id}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data.data);
                    } else if (data.code === "invalid field") {
                        reject(["No data"]);
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};

export const addNewRole = async (role) => {
    const request = requestAuthOption("POST", role)
    try {
        const response = await fetch(`${server}role`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                    } else {
                        reject(data);
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};

export const delRole = async (payload) => {
    let request = {}
    if (payload?.multiple) {
        request = requestAuthOption("DELETE", payload?.id)
    } else {
        request = requestAuthOption("DELETE")

    } try {
        const response = payload?.multiple ? await fetch(`${server}role`, request) : await fetch(`${server}role/${payload?.id}`, request)
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        reject(data);
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    resolve({ data: data, api: payload?.api });
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};

export const updateRole = async ({ id, role }) => {
    const request = requestAuthOption("PUT", role)
    try {
        const response = await fetch(`${server}role/${id}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject(data);
                    } else {
                        reject(data);
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};

export const roleUserAssign = async (payload) => {
    const request = requestAuthOption("PUT", payload?.data)
    try {
        const response = await fetch(`${server}role/assign_user/${payload.id}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        reject(data);
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};